export default __webpack_public_path__ + "static/media/Factor-momentum-Money-control_New.097b4c9c.gif";